import * as Types from "actions/types";

import defaultImage from "assets/img/default-avatar.png";

const initialState = {
  isLoaded: false,
  roles: Types.USER_ROLES_INITIAL_STATE,
  userDetails:{},
  stripeConnectLink: null,
  stripeLoginLink: null,
  transfers: [],
}
export default (state = initialState, action) => {
//console.log(action);
  switch(action.type) {
    case Types.RETRIEVE_SESSION_USER_DETAILS_SUCCESS:
      return {
        ...state,
        userDetails: action.userDetails,
        userAvatar: "https://media.dev.mysafedelivery.com/"+action.userDetails.cognitoId+"/avatar-500x500.png",
        roles: action.userDetails.roles,
        isLoaded: true,
      }
    case Types.USER_APPLICATION_SUCCESS: 
    case Types.USER_PUT_DETAILS_SUCCESS: 
      return {
        ...state,
        userDetails: action.userDetails,
        roles: action.userDetails.roles,
        isLoaded: true,
      }  
    case Types.USER_UPLOAD: 
      return {
        ...state,
        userAvatar: defaultImage,
      }  
    case Types.USER_UPLOAD_SUCCESS: 
      return {
        ...state,
        userAvatar: "https://media.dev.mysafedelivery.com/"+action.userId+"/avatar-500x500.png?"+Date.now(),
      }  
    case Types.PAYMENTS_GET_STRIPE_CONNECT_LINK_SUCCESS: 
      return {
        ...state,
        stripeConnectLink: action.link,
        stripeLoginLink: null,
      }   
    case Types.PAYMENTS_GET_STRIPE_LOGIN_LINK_SUCCESS: 
      return {
        ...state,
        stripeConnectLink: null,
        stripeLoginLink: action.link,
      }
    case Types.PAYMENTS_GET_TRANSFERS_SUCCESS: 
      return {
        ...state,
        transfers: action.transfers,
      }
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/user.js